// Override Settings
var bcSfFilterSettings = {
    general: {
       	limit: bcSfFilterConfig.custom.products_per_row * bcSfFilterConfig.custom.number_of_rows,
        /* Optional */
        loadProductFirst: true,
        activeScrollToTop: true,
      	collapseOnPCByDefault: true,
      	collapseOnMobileByDefault: true,
        activeFilterScrollbar: false,
        sortingList: ['manual', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'created-descending', 'created-ascending', 'sale-descending']
    },
    // Optional, customize when customer need translate
    label: {
        sorting: {
           // 'manual' : bcSfFilterConfig.label.sorting_featured, 
           //// 'title-ascending': bcSfFilterConfig.label.sorting_title_ascending,
          //  'title-descending': bcSfFilterConfig.label.sorting_title_descending,
          //  'price-ascending' : bcSfFilterConfig.label.sorting_price_ascending, 
          //  'price-descending' : bcSfFilterConfig.label.sorting_price_descending,
          //  'created-descending': bcSfFilterConfig.label.sorting_date_descending, 
          //  'created-ascending': bcSfFilterConfig.label.sorting_date_ascending,
            'sale-descending': '% Off',
        }
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'typeItemClass': 'type-item',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<li class="product-list-item {{soldOutClass}} {{saleClass}} {{typeItemClass}}">' +
                              '<a class="wrap-link" href="{{itemUrl}}">' +
                                  '<div class="item-inner">' +
                                      '<div class="prod-image-wrap">' +
                                          '<a href="{{itemUrl}}">' +
                                              '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                          '</a>' +
                                      '</div>' +
                                      '<div class="product-details">' +
                                          '<div class="inner">' +
                                              '{{itemVendor}}' +
                                              //'{{itemFilter}}' +
                                          '</div>' +
                                      '</div>' +
                                      '<div class="add-area">' +
                                          '<div class="price-area">' +
                                              '<p class="price-p" itemprop="offers" itemscope itemtype="http://schema.org/Offer" class="delta">' +
                                                  '{{itemPrice}}' +
                                                  '{{itemTitleCaseOf}}' +
                                              '</p>' +
                                          '</div>' +
  										 '{{itemAddToCart}}' +
                                      '</div>' +
                                  '</div>' +
                              '</a>' +
                          '</li>',

    // List Template
    'productListItemHtml': '',

    // Pagination Template
    'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}">&lt;</a></span>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}">&gt;</a></span>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
    'paginateHtml': '<div class="pagination centered">{{previous}}{{pageItems}}{{next}}</div>',
  
    // Sorting Template
    'sortingHtml': '<select class="sort-by right">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') {
            firstVariant = paramVariant[0];
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add soldOut class
    var soldOutClass = '';
    if (soldOut) {
      soldOutClass = bcSfFilterTemplate.soldOutClass;
    }
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  
  	var typeItemClass = '';
  	itemHtml = itemHtml.replace(/{{typeItemClass}}/g, typeItemClass);
  
  	//Add Vendor
  	var vendorImage = this.slugify(data.vendor) + '.jpg';
    var imageUrlSrc = bcSfFilterConfig.general.asset_url;
    imageUrlSrc = imageUrlSrc.replace('bc-sf-filter.js', vendorImage);
    var vendor_url = this.buildProductItemVendorUrl(data.vendor);
    var itemVendorHtml = ' <a class="vendor-logo" href="' + vendor_url + '" itemprop="brand"><img src="' + imageUrlSrc + '" alt="' + data.vendor + '" /></a>';
    var vendorRemove = data.title.split(" - ").shift();
    var mainTitle = data.title.split(" - ");
    itemVendorHtml += '<h3 itemprop="name">' + mainTitle[1] + '<span class="size">'+ mainTitle[2]+'</span></h3>';
    itemVendorHtml += '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add Price
    var variant = firstVariant;
    var itemPriceHtml = '';
    itemPriceHtml += '<meta itemprop="priceCurrency" content="' + bcSfFilterConfig.shop.currency+ '" />';
  	itemPriceHtml += '<input type="hidden" class="price-origin" value="' + variant.price + '" />'; 
    if(data.available) {
        itemPriceHtml += '<link itemprop="availability" href="http://schema.org/InStock" />'; 
    } else {
        itemPriceHtml += '<link itemprop="availability" href="http://schema.org/OutOfStock" />';    
    }
    if(onSale) {
        itemPriceHtml += '<s class="product-compare-price">' + this.formatMoney(variant.compare_at_price, this.moneyFormat) + '</s>';
        itemPriceHtml += ' <span class="product-price on-sale" itemprop="price">' + this.formatMoney(variant.price, this.moneyFormat) + '</span>';
    } else {
        itemPriceHtml += '<span class="product-price" itemprop="price">' + this.formatMoney(variant.price, this.moneyFormat).replace(" ", "") + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    var itemTitleCaseOfHtml = '';
  	for (var k in data.tags) {
      	var tag = data['tags'][k];
      	if (tag.indexOf('Set of') > 1) {
          	itemTitleCaseOfHtml += ' <p class="sub-price case-of">' + tag + '</p>';
          	var setQty = tag.split('Set of ').pop();
          	itemTitleCaseOfHtml += '<div class="priceBox"><span>' + this.formatMoney((variant.price / setQty), this.moneyFormat) + ' per unit</span></div>';   
        } else if (tag.indexOf('Box of') > -1 ) {
          	itemTitleCaseOfHtml += ' <p class="sub-price case-of">' + tag + '</p>';
          	var setQty = tag.split('Box of ').pop();
            itemTitleCaseOfHtml += '<div class="priceBox"><span>' + this.formatMoney((variant.price / setQty), this.moneyFormat) + ' per unit</span></div>';   
          if( setQty < 2){
          	 itemTitleCaseOfHtml = '';
          }
        }
  	}
  	if (itemTitleCaseOfHtml == '') {
    	itemTitleCaseOfHtml = '<div class="priceBox"></div>';
    }
    itemHtml = itemHtml.replace(/{{itemTitleCaseOf}}/g, itemTitleCaseOfHtml);
  
  	//Add Product Button
 	var itemAddToCartHtml = '';
    var classFilter = bcSfFilterConfig.custom.isFilter ? 'filter' : '';
    itemAddToCartHtml += '<div class="product-add ' + classFilter + '">';
    itemAddToCartHtml += '<form action="/cart/add" method="post" style="text-align:left;">';
  	itemAddToCartHtml += '<div class="qtyBox">';
  	itemAddToCartHtml += '<label>Qty</label><input class="colQuantity" type="number" id="Quantity" name="quantity" value="1" min="1" class="qty-remove-defaults quantity-selector">  ';
  	itemAddToCartHtml += '</div>';
	itemAddToCartHtml += '<select name="id" style="display:none;">';
  	for (var k in data.variants) {
      	var variant = data['variants'][k];
      	if (variant.available) {
          	if (k == 0) {
              	var basePrice = variant.price;
              	itemAddToCartHtml += '<option value="' + variant.id + '">' + variant.title + '</option>';
            } else {
              	var addPrice = variant.price - basePrice;
        		itemAddToCartHtml += '<option value="' + variant.id + '">' + variant.title + ' ( +' + this.formatMoney(addPrice, this.moneyFormat) + ' )</option>';
            }
        } else {
          	itemAddToCartHtml += '<option disabled="disabled">' + variant.title + ' - Sold Out</option>';
        }
  	}
        	if (variant.available) {
    itemAddToCartHtml += '<input class="button primary" type="submit" value="Add to Cart" />';
            }else{
            	itemAddToCartHtml += '<input id="soldOut" class="button primary" type="submit" value="Sold Out" disabled="disabled" style="background-color: rgba(28,57,105,.6) !important;" />';
            }
    itemAddToCartHtml += '</form>';
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {};

// Customize data to suit the data of Shopify API
// Using for building Variants
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];

            var variantOptions = variant['merged_options'];
            for (var j in variantOptions) {
                var temp = variantOptions[j].split(':');
                data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                variantOptionArr.push(temp[1]);
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
            data[k]['variants'][i]['options'] = variantOptionArr;
        }
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
	window.innerShiv=function(){function e(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var t,r,a=document,i="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(n,s){if(!t&&(t=a.createElement("div"),t.innerHTML="<nav></nav>",r=1!==t.childNodes.length)){for(var o=a.createDocumentFragment(),d=i.length;d--;)o.createElement(i[d]);o.appendChild(t)}if(n=n.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,e),t.innerHTML=(o=n.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+n+"</table>":n,o=o?t.getElementsByTagName(o[1])[0].parentNode:t,!1===s)return o.childNodes;for(var d=a.createDocumentFragment(),u=o.childNodes.length;u--;)d.appendChild(o.firstChild);return d}}(),function(){window.SPR=function(){function e(){}return e.shop=Shopify.shop,e.host="//productreviews.shopifycdn.com",e.version="v4",e.api_url=e.host+"/proxy/"+e.version,e.badgeEls=[],e.reviewEls=[],e.elSettings={},e.$=void 0,e.extraAjaxParams={shop:e.shop},e.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},e.loadStylesheet=function(){var e,t;return t=document.createElement("link"),t.setAttribute("rel","stylesheet"),t.setAttribute("type","text/css"),t.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-05d8adfa7bfbbb65c5fb55b0659d8fa6f7d297faa9930816634a789969c02a13.css"),t.setAttribute("media","screen"),e=document.getElementsByTagName("head")[0],e.appendChild(t)},e.initRatingHandler=function(){return e.$(document).on("mouseover mouseout","form a.spr-icon-star",function(t){var r,a,i;return r=t.currentTarget,i=e.$(r).attr("data-value"),a=e.$(r).parent(),"mouseover"===t.type?(a.find("a.spr-icon:lt("+i+")").addClass("spr-icon-star-hover"),a.find("a.spr-icon:gt("+(i-1)+")").removeClass("spr-icon-star-hover")):a.find("a.spr-icon").removeClass("spr-icon-star-hover")})},e.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(e){return function(t,r){var a;return a=e.$(r).attr("data-id"),e.elSettings[a]={},e.elSettings[a].reviews_el="#"+(e.$(r).attr("data-reviews-prefix")?e.$(r).attr("data-reviews-prefix"):"reviews_"),e.elSettings[a].form_el="#"+(e.$(r).attr("data-form-prefix")?e.$(r).attr("data-form-prefix"):"form_")}}(this))},e.loadProducts=function(){return this.$.each(this.reviewEls,function(e){return function(t,r){var a,i;if(a=e.$(r).attr("data-id"),"false"!==e.$(r).attr("data-autoload"))return i=e.$.extend({product_id:a,version:e.version},e.extraAjaxParams),e.$.get(e.api_url+"/reviews/product",i,e.productCallback,"jsonp")}}(this))},e.loadBadges=function(){var e,t,r,a,i;if(r=this.$.map(this.badgeEls,function(e){return function(t){return e.$(t).attr("data-id")}}(this)),r.length>0){for(t=7,i=[];(e=r.splice(0,t)).length>0;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},e.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},e.submitForm=function(e){var t;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=this.$.param(t),t=t.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:function(e){return function(){return e.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(e){return function(){return e.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},e.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},e.toggleReviews=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-reviews").toggle()},e.toggleForm=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-form").toggle()},e.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},e.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},e.badgesCallback=function(t){var r;return r=t.badges,e.$.map(e.badgeEls,function(t){var a;if(a=e.$(t).attr("data-id"),r[a]!==undefined)return e.$(t).replaceWith(r[a]),e.$(document).trigger("spr:badge:loaded",{id:a})})},e.productCallback=function(t){var r;return r=t.remote_id.toString(),e.renderProduct(r,t.product),e.renderForm(r,t.form),e.renderReviews(r,t.reviews)},e.renderProduct=function(e,t){return this.$.map(this.reviewEls,function(r){return function(a){if(e===r.$(a).attr("data-id"))return r.$(a).html(innerShiv(t,!1)),r.$(document).trigger("spr:product:loaded",{id:e})}}(this))},e.renderForm=function(e,t){var r;return r=this.$(this.elSettings[e].form_el+e),r.html(t),this.$(document).trigger("spr:form:loaded",{id:e})},e.renderReviews=function(t,r){var a;return a=e.$(e.elSettings[t].reviews_el+t),a.html(r),e.$(document).trigger("spr:reviews:loaded",{id:t})},e.formCallback=function(t){var r,a,i,n;return n=t.status,i=t.remote_id,a=t.form,r=e.$(e.elSettings[i].form_el+i),r.html(a),"failure"===n&&e.initStarRating(r),"success"===n&&e.$("#shopify-product-reviews[data-id='"+i+"'] .spr-summary-actions-newreview").hide(),e.$(document).trigger("spr:form:"+n,{id:i})},e.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},e.paginateCallback=function(t){var r,a;return a=t.remote_id.toString(),r=t.reviews,e.renderReviews(a,r)},e.reportCallback=function(t){var r;return r="#report_"+t.id,e.$(r).replaceWith("<span class='spr-review-reportreview'>"+e.$(r).attr("data-msg")+"</span>")},e.loadjQuery=function(t){return e.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return e.$=jQuery.noConflict(!0),t()})},e.loadScript=function(e,t){var r;return r=document.createElement("script"),r.type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},e.loadjQueryExtentions=function(e){return e.fn.serializeObject=function(){var t,r;return t={},r=this.serializeArray(),e.each(r,function(){return t[this.name]?(t[this.name].push||(t[this.name]=[t[this.name]]),t[this.name].push(this.value||"")):t[this.name]=this.value||""}),t}},e}(),function(){SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}.call(this);
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
    
  	$('.filter_count').html(data.total_product + ' Items');
	jQ('.bc-sf-filter-option-multiple-list').each(function() {
      	jQ(this).children().slice(5).hide();
  	})
  	jQ('.bc-sf-filter-option-multiple-list').each(function() {
      	if (jQ(this).children().length > 5) {
          	jQ(this).after('<li href="javascript:;" class="bc-sf-filter-see-more">See More</li>');
      	}
  	});
  	jQ('.bc-sf-filter-see-more').on('click', function() {
      	jQ(this).siblings().children().show();
      	jQ(this).hide();
  	});
  
	$(".bc-sf-filter-option-single-list").each(function(){
       $(this).find("li:gt(4)").hide();    
       if($(this).find("li").length > 5)
			$(this).append("<li class='moreless more'>See More</li>") ;          
    });
    
    $(".moreless").on("click", function(){
       if($(this).hasClass("more"))
       {
           $(this).prevAll("li").show();
           $(this).text("See Less").addClass("less").removeClass("more");
       }
       else if($(this).hasClass("less"))
       {
           $(this).prevAll("li").hide();
           $(this).parent().find("li:lt(5)").show();
           $(this).text("See More").addClass("more").removeClass("less");
       }
    });
  
  	var _this = this;
  	/*$(document).on('change paste keyup', '.colQuantity', function() {
        if ($(this).val() >= 13) {
          	window.location.href="{{settings.qtyRedirect}}";
        } else {
          	var currentPriceSelector = $(this).closest('.product-add').siblings('.price-area').find('.price-origin');
      		var currentPrice = $(currentPriceSelector).val();
      		var qty = parseInt($(this).val());
            if (qty > 0) {
      			var newPrice = _this.formatMoney(currentPrice * qty, _this.moneyFormat).replace(' ', '');
				$(currentPriceSelector).siblings('.product-price').html(newPrice);
            }
        }
    });*/
    $(document).on('init', '.unitPrice', function(){
      	alert($(this).html());
    });
  
  	// Build breadcrumb
  	var query = '';
  	var params = this.queryParams;
  	if (params.hasOwnProperty('pf_t_filter_type') && params['pf_t_filter_type'].length > 0)
      	query = params['pf_t_filter_type'].pop();
	if (params.hasOwnProperty('pf_t_category') && params['pf_t_category'].length > 0)
      	query = params['pf_t_category'].pop();
	if (params.hasOwnProperty('pf_t_product_line') && params['pf_t_product_line'].length > 0)
      	query = params['pf_t_product_line'].pop();
	if (params.hasOwnProperty('pf_t_merv') && params['pf_t_merv'].length > 0)
      	query = params['pf_t_merv'].pop();   
  // Hack by previous developer that was overriding the breadcrumbs
  	var html = '<li><a href="/">Home</a></li>';
  	if (query != '') {
        html += ' <li><a href="/collections/filters">Filters</a></li>';
        html += ' <li>' + query + '</li>';
      jQ('.breadcrumb').html(html);
    } else {
      jQ('.breadcrumb li:nth-child(3)').remove();
    }
  	
};


document.getElementById("bc-sf-filter-tree-mobile-button").value="Filter";
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
